import type { RoundSnapshot } from "../contracts/RoundSnapshot";

/**
 * The round's total win: the last event's accumulatedWinAmountAfterEvent, which the snapshot validator
 * requires (decision 26); undefined only for a round without events. ClientEngine settles the round when
 * it is > 0.
 */
export function extractLastNonEmptyAccumulatedWinAmount(roundSnapshot: RoundSnapshot): string | undefined {
  const events = roundSnapshot.orderedEvents;

  for (let i = events.length - 1; i >= 0; i--) {
    const candidate = events[i].accumulatedWinAmountAfterEvent;
    if (typeof candidate === "string" && candidate.length > 0) {
      return candidate;
    }
  }

  return undefined;
}